export enum DateAdjustmentRuleEnum {
  NA,
  'Sunday/PHoliday Forward',
  'Sunday/PHoliday Backward',
  'Weekend Forward',
  'Weekend Back',
  'Leave On'
}

export namespace DateAdjustmentRuleEnum {
  export function values() {
    return Object.keys(DateAdjustmentRuleEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
